import { render, staticRenderFns } from "./SaleOrders.vue?vue&type=template&id=1d57ce03&"
import script from "./SaleOrders.vue?vue&type=script&lang=js&"
export * from "./SaleOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports